import React, { useEffect } from 'react';
import TrainingApp from '../components/training/TrainingApp';
import '../styles/dashboard-pages.css';
import './TrainingPage.css';

const NewTrainingPage: React.FC = () => {
  useEffect(() => {
    // Prevent scrollbar flash by hiding overflow on content-area
    const contentArea = document.querySelector('.content-area');
    if (contentArea) {
      contentArea.classList.add('training-page-active');
    }
    return () => {
      if (contentArea) {
        contentArea.classList.remove('training-page-active');
      }
    };
  }, []);

  return (
    <div className="training-page">
      <TrainingApp />
    </div>
  );
};

export default NewTrainingPage;

